import { handlePhrasesParams, isJsonString } from "vendor/application";
import { showNotify } from "vendor/application/disptach";
import { validateEquivalences } from "./validateEquivalences";
import { validateZendeskEquivalences } from "./validateZendeskEquivalences";
import { validExtensions } from "./validExtensions";
import { parseVariablesDeskEdit } from "./parseVariablesEdit";

export const handleIntent = async ({
  intent,
  variables,
  dispatch,
  handleAddVariables,
  handleAddEquivalences,
  saveIntentFn,
  type,
}) => {
  const extensionsExist = intent.extensions && intent.extensions.url;
  const initialPayload = intent.extensions.body?.payload;
  let updatedPayload;

  if (initialPayload && typeof initialPayload === "string") {
    updatedPayload = initialPayload.replace(
      /:\s*(\$\.\w+(\.\w+)*\b)/g,

      ': "$1"'
    );
  } else {
    updatedPayload = initialPayload;
  }

  if (validateEquivalences(variables, dispatch)) return;
  if (validateZendeskEquivalences(variables, dispatch)) return;

  if (!validExtensions(variables, dispatch)) {
    return;
  }

  const validVariables = variables.filter(
    (variable) => variable && variable.variable
  );

  if (extensionsExist && !intent.extensions.timeout) {
    intent.extensions.timeout = 15;
  }

  if (intent.extensions.method) {
    intent.extensions.variables = handleAddVariables(variables);
    intent.extensions.equivalences = handleAddEquivalences(variables);
  }

  let value = true;
  const body = intent.extensions.body?.payload;
  const payload = updatedPayload ? updatedPayload : body;

  if (
    intent.extensions.body?.type === "application/json" &&
    payload &&
    !isJsonString(payload)
  ) {
    value = false;
  }

  if (
    intent.extensions.body?.type === "application/json" &&
    payload &&
    !isJsonString(payload)
  ) {
    value = false;
  }
  if (!value) {
    const data = {
      message: "extension_body_has_an_invalid_value",
      severity: "error",
    };
    dispatch(showNotify(data));
  } else if (handlePhrasesParams(intent, dispatch)) {
    const send_intent = JSON.parse(JSON.stringify(intent));

    send_intent.parameters.forEach((param, i) => {
      if (param.zendesk_ticket_field) {
        delete send_intent.parameters[i].zendesk_ticket_field
          .custom_field_options;
        delete send_intent.parameters[i].zendesk_ticket_field
          .custom_field_options_actual;
      }

      if (
        param.zendesk_ticket_field &&
        (param.zendesk_ticket_field.desk_id === null ||
          !param.zendesk_ticket_field.id)
      ) {
        send_intent.parameters[i].zendesk_ticket_field = {};
      }
    });

    const zendesk_ticket_status = send_intent.desks.info.zendesk_ticket_status;
    const zendesk_mode = send_intent.desks.info.zendesk_mode;
    const centridesk_ticket_status =
      send_intent.desks.info.centridesk_ticket_status;
    const centridesk_mode = send_intent.desks.info.centridesk_mode;

    if (send_intent.desks.name === "zendesk_full") {
      send_intent.desks.info.ticket_status = zendesk_ticket_status;
      send_intent.desks.info.mode = zendesk_mode;
    } else if (send_intent.desks.name === "centridesk") {
      send_intent.desks.info.ticket_status = centridesk_ticket_status;
      send_intent.desks.info.mode = centridesk_mode;
    }

    if (send_intent.desks.name === "gpt-3") {
      send_intent.desks.info = {
        max_tokens: intent.desks.info.max_tokens,
        max_interactions: intent.desks.info.max_interactions,
      };
    } else {
      delete send_intent.desks.info.max_tokens;
      delete send_intent.desks.info.max_interactions;
    }

    if (send_intent.conditional_responses.length > 0) {
      send_intent.conditional_responses.forEach((conditional) => {
        delete conditional.param0;
      });
    }

    delete send_intent.desks.info.zendesk_ticket_status;
    delete send_intent.desks.info.centridesk_ticket_status;
    delete send_intent.desks.info.zendesk_mode;
    delete send_intent.desks.info.centridesk_mode;

    if (
      send_intent.extensions.variables &&
      send_intent.extensions.variables_desk
    ) {
      const validIds = validVariables;
      send_intent.extensions.variables_desk.forEach((variableDesk, index) => {
        if (send_intent.extensions.variables[index] === variableDesk.name) {
          variableDesk.name = send_intent.extensions.variables[index];
        }
      });
      const allowedVariableNames = send_intent.extensions.variables.map(
        (variable) => variable
      );
      send_intent.extensions.variables_desk = parseVariablesDeskEdit(
        send_intent.extensions.variables_desk,
        allowedVariableNames,
        validIds
      );
    }

    if (send_intent.extensions.auth) {
      delete send_intent.extensions.auth.access_key_input;
    }

    if (!send_intent.desks?.name) {
      send_intent.desks = null;
    }

    if (
      send_intent.desks?.name === "zendesk_full" &&
      !send_intent.desks.info.desk_id
    ) {
      dispatch(showNotify({ message: "no_desk_id_intent", severity: "error" }));
      return;
    }

    if (type === "create") {
    } else {
      await saveIntentFn(send_intent);
    }
  }
};
